"use client";

import { c as _c } from "react/compiler-runtime";
import { cloneElement, isValidElement, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import type { CommonSelectItemProps } from "../CommonSelect";
import { SortDirection } from "@/entities/ISort";
export default function CommonDropdownItem(props) {
  const $ = _c(38);
  const {
    item,
    activeItem,
    setSelected,
    sortDirection,
    children,
    isMobile
  } = props;
  const [isActive, setIsActive] = useState(item.value === activeItem);
  let t0;
  if ($[0] !== activeItem || $[1] !== item.value) {
    t0 = () => {
      setIsActive(item.value === activeItem);
    };
    $[0] = activeItem;
    $[1] = item.value;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== activeItem) {
    t1 = [activeItem];
    $[3] = activeItem;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  const [shouldRotate, setShouldRotate] = useState(false);
  let t2;
  if ($[5] !== item.value || $[6] !== setSelected) {
    t2 = () => {
      setSelected(item.value);
      setShouldRotate(false);
    };
    $[5] = item.value;
    $[6] = setSelected;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onSelected = t2;
  let t3;
  if ($[8] !== item.label || $[9] !== item.mobileLabel) {
    t3 = () => item.mobileLabel ?? item.label;
    $[8] = item.label;
    $[9] = item.mobileLabel;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const getLabel = t3;
  let t4;
  if ($[11] !== getLabel) {
    t4 = getLabel();
    $[11] = getLabel;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const [label, setLabel] = useState(t4);
  let t5;
  if ($[13] !== getLabel) {
    t5 = () => {
      setLabel("Copied!");
      setTimeout(() => {
        setLabel(getLabel());
      }, 1000);
    };
    $[13] = getLabel;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const onCopy = t5;
  const t6 = `${isMobile ? "tw-px-4 tw-py-3" : "tw-px-3 tw-py-2"} tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-2 tw-rounded-md tw-border-0 tw-bg-transparent tw-text-left tw-text-sm tw-font-medium tw-text-iron-200 tw-transition tw-duration-200 tw-ease-out hover:tw-bg-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${isActive ? "tw-bg-iron-800 tw-text-iron-100" : ""}`;
  let t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShouldRotate(true);
    t8 = () => setShouldRotate(false);
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== label) {
    t9 = <span className="tw-truncate tw-text-sm tw-font-medium">{label}</span>;
    $[17] = label;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isActive || $[20] !== shouldRotate || $[21] !== sortDirection) {
    t10 = sortDirection && <span className="-tw-mt-0.5"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} shouldRotate={isActive && shouldRotate} /></span>;
    $[19] = isActive;
    $[20] = shouldRotate;
    $[21] = sortDirection;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== activeItem || $[24] !== item.value) {
    t11 = item.value === activeItem && <FontAwesomeIcon icon={faCheck} className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-primary-300 tw-transition tw-duration-200 tw-ease-out" aria-hidden="true" />;
    $[23] = activeItem;
    $[24] = item.value;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t9) {
    t12 = <div className="tw-flex tw-flex-1 tw-items-center tw-gap-x-2 tw-min-w-0">{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== children || $[31] !== onCopy) {
    t13 = isValidElement(children) && cloneElement(children, {
      onCopy
    });
    $[30] = children;
    $[31] = onCopy;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== onSelected || $[34] !== t12 || $[35] !== t13 || $[36] !== t6) {
    t14 = <li className="tw-h-full" role="none"><button type="button" className={t6} role="menuitem" onClick={onSelected} onMouseEnter={t7} onMouseLeave={t8}>{t12}{t13}</button></li>;
    $[33] = onSelected;
    $[34] = t12;
    $[35] = t13;
    $[36] = t6;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}